import { useState } from "react";
import { TarjetaRegistro } from './TarjetaRegistro';

export const GrupoMes = ({ clave, grupo, onEliminar, onExport, seleccionados, onToggleSeleccion }) => {
  const [abierto, setAbierto] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <button
        onClick={() => setAbierto(a => !a)}
        className="w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-gray-50 transition-all"
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-gray-700">
            📅 {grupo.label.charAt(0).toUpperCase() + grupo.label.slice(1)}
          </span>
          <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">{grupo.registros.length}</span>
          {grupo.registros.some(r => seleccionados.has(r.id)) && (
            <span className="text-xs bg-blue-100 text-blue-700 font-bold px-2 py-0.5 rounded-full">
              {grupo.registros.filter(r => seleccionados.has(r.id)).length} sel.
            </span>
          )}
        </div>
        <span className="text-gray-400 text-sm">{abierto ? "▲" : "▼"}</span>
      </button>
      {abierto && (
        <div className="px-3 pb-3 space-y-2 bg-gray-50">
          {grupo.registros.map(r => (
            <TarjetaRegistro
              key={r.id}
              r={r}
              esAdmin={true}
              onEliminar={onEliminar}
              onExport={onExport}
              seleccionable={true}
              seleccionado={seleccionados.has(r.id)}
              onToggleSeleccion={onToggleSeleccion}
            />
          ))}
        </div>
      )}
    </div>
  );
};
